export default __webpack_public_path__ + "static/media/photo10.258d72c0.jpg";